export default {
  allLoggingMethods: (state) => state.loggingMethods,
  loggingMethodsLoading: (state) => state.loading
}
